import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { setupErrorReporting } from './report';
import reportWebVitals from './reportWebVitals';

// Log unhandled errors to the API service.
setupErrorReporting();

// dummy log to test deployment

ReactDOM.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
